var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.003 4.822c4.07 0 7.081 2.72 7.081 6.59 0 3.868-3.011 6.588-7.081 6.588s-7.082-2.72-7.082-6.589 3.011-6.589 7.082-6.589Zm25.867 0c3.16 0 5.258 1.501 6.078 3.714l-3.695 1.498-.013.003c-.306-1.177-1.003-1.85-2.175-1.85-1.421 0-2.509 1.065-2.509 3.224 0 2.159 1.088 3.224 2.51 3.224 1.253 0 1.978-.812 2.257-2.156l2.903 1.18.836.337C53.322 16.368 51.172 18 47.87 18c-4.042 0-6.914-2.552-6.914-6.589 0-4.01 2.872-6.589 6.914-6.589Zm-39.088 0c3.43 0 4.796 2.383 4.796 4.99v7.851H9.061v-6.757c0-1.71-.752-2.607-2.119-2.607-1.533 0-2.425 1.346-2.425 3.224v6.14H0V6.658l4.517-1.835v2.495C5.13 5.86 6.942 4.822 8.782 4.822ZM59.938 0v7.318c.614-1.458 2.426-2.496 4.266-2.496 3.43 0 4.796 2.383 4.796 4.99v7.851h-4.517v-6.757c0-1.71-.752-2.607-2.119-2.607-1.533 0-2.425 1.346-2.425 3.224v6.14h-4.517V1.835L59.938 0Zm-22.44 1.385v3.06l4.298-1.747v3.335L37.498 7.78v9.877H33.12V9.558l-2.898 1.178V7.4l2.898-1.177v-3.06l4.378-1.778Zm-15.495 6.69c-1.59 0-2.482 1.346-2.482 3.336 0 1.99.892 3.337 2.482 3.337 1.589 0 2.481-1.346 2.481-3.337 0-1.99-.892-3.336-2.481-3.336Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h69v18H0z"
  })))));
};

export default SvgLogoIcon;